import { GOOGLE_ADS } from './google-ads-config';
import { useInitClarity } from './useInitClarity';

export function loadThirdPartyScripts() {
  onUserInteraction(() => {
    loadGoogleAnalytics();
    loadFacebookPixel();
    loadHotjar();
    loadMailchimp();
    loadChatwoot();
    useInitClarity();
    // loadIntercom();
  });
}

function onUserInteraction(callback) {
  let fired = false;
  const handler = () => {
    if (!fired) {
      fired = true;
      callback();
    }
  };
  ['scroll', 'mousemove', 'keydown', 'touchstart'].forEach(event =>
    window.addEventListener(event, handler, { once: true })
  );
}

// FACEBOOK PIXEL
function loadFacebookPixel() {
  (function (f, b, e, v, n, t, s) {
    if (f.fbq) return;
    n = f.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    };
    if (!f._fbq) f._fbq = n;
    n.push = n;
    n.loaded = !0;
    n.version = '2.0';
    n.queue = [];
    t = b.createElement(e);
    t.async = true;
    t.src = v;
    s = b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t, s);
  })(
    window,
    document,
    'script',
    'https://connect.facebook.net/en_US/fbevents.js'
  );

  window.fbq('init', '3947774575496031');
  window.fbq('track', 'PageView');
}

// GOOGLE ANALYTICS
function loadGoogleAnalytics() {
  const script = document.createElement('script');
  script.src = `https://www.googletagmanager.com/gtag/js?id=${process.env.REACT_APP_GOOGLE_ANALYTICS_ID}`;
  script.async = true;
  document.head.appendChild(script);

  script.onload = () => {
    window.dataLayer = window.dataLayer || [];
    function gtag() {
      window.dataLayer.push(arguments);
    }
    window.gtag = gtag;

    gtag('js', new Date());
    gtag('config', process.env.REACT_APP_GOOGLE_ANALYTICS_ID);
    gtag('config', GOOGLE_ADS.CONVERSION_ID);
  };
}

// HOTJAR
function loadHotjar() {
  (function (h, o, t, j, a, r) {
    h.hj =
      h.hj ||
      function () {
        (h.hj.q = h.hj.q || []).push(arguments);
      };
    h._hjSettings = { hjid: 2794946, hjsv: 6 };
    a = o.getElementsByTagName('head')[0];
    r = o.createElement('script');
    r.async = 1;
    r.src = `${t}${h._hjSettings.hjid}${j}${h._hjSettings.hjsv}`;
    a.appendChild(r);
  })(window, document, 'https://static.hotjar.com/c/hotjar-', '.js?sv=');
}

// MAILCHIMP
function loadMailchimp() {
  const script = document.createElement('script');
  script.src =
    'https://s3.amazonaws.com/downloads.mailchimp.com/js/mc-validate.js';
  script.async = true;
  document.head.appendChild(script);

  script.onload = () => {
    try {
      (function ($) {
        window.fnames = [];
        window.ftypes = [];

        window.fnames[0] = 'EMAIL';
        window.ftypes[0] = 'email';
        window.fnames[1] = 'FNAME';
        window.ftypes[1] = 'text';
        window.fnames[3] = 'ADDRESS';
        window.ftypes[3] = 'address';
        window.fnames[4] = 'PHONE';
        window.ftypes[4] = 'phone';
      })(window.jQuery || []);
    } catch (e) {
      console.warn('Mailchimp init failed', e);
    }
  };
}

// CHATWOOT
function loadChatwoot() {
  const BASE_URL = 'https://engage.myserviceagent.net';
  const script = document.createElement('script');
  script.src = `${BASE_URL}/packs/js/sdk.js`;
  script.defer = true;
  script.async = true;
  document.head.appendChild(script);

  script.onload = () => {
    window.chatwootSDK.run({
      websiteToken: 'fEf3snSSq1vDbTJT5mdBgRA4',
      baseUrl: BASE_URL
    });
  };
}

// INTERCOM
// function loadIntercom() {
//   if (window.Intercom) {
//     window.Intercom('reattach_activator');
//     window.Intercom('update', window.intercomSettings);
//   } else {
//     const script = document.createElement('script');
//     script.src = 'https://widget.intercom.io/widget/vhh73m4r';
//     script.async = true;
//     document.head.appendChild(script);
//   }
// }
